import $ from "jquery"

class AnchorLink {
	constructor() {
		if (window.location.hash && !window.location.hash.includes("=")) {
			//window.scroll(0, 0)

			const $scrollItem = $(window.location.hash)
			if ($scrollItem.length > 0) {
				this._scrollToAnchorLink($scrollItem)
			}
		}

		$("body").on("click", 'a[href^="#"]:not(.bb-jump-links__link)', (e) => {
			const $item = $(e.target.hash)

			if ($item.length > 0) {
				e.preventDefault()
				this._scrollToAnchorLink($item)
			}
		})
	}

	_scrollToAnchorLink($item) {
		// if item is not visible try to make it visible, for example open tab in tab component
		if ($item.is(":hidden")) {
			const $tabContent = $item.closest(".bb-tabs__content")
			if ($tabContent.length > 0 && !$tabContent.hasClass("active")) {
				$("#" + $tabContent.attr("aria-labelledby")).trigger("click")
				window.setTimeout(() => this._scrollToAnchorLink($item), 210)
				return false
			}
		}

		// only scrolling to visible elements possible
		if ($item.is(":visible")) {
			const $header = $("#bb-header")
			let headerHeight = 0
			if ($header.length) {
				headerHeight = $header.outerHeight()
			}

			$item.attr("tabindex") ? $item.focus() : $item.attr({"tabindex": 0}).focus().removeAttr("tabindex")

			const scrollPos = $item.offset().top - headerHeight - 20
			const scrollDuration = 700 + ($(window).scrollTop() - scrollPos) * 0.08
			$("html, body")
				.stop()
				.animate({ scrollTop: scrollPos + "px" }, scrollDuration, () => {
					// Hide menu
					$("html, body").animate({ scrollTop: (scrollPos + 1) + "px" }, 0)
				})
		}
	}
}

export default AnchorLink
